"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GTM_COUNTER_IDS = exports.initializeGtm = void 0;
function initializeGtm(counterId) {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
            '//www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', counterId);
}
exports.initializeGtm = initializeGtm;
exports.GTM_COUNTER_IDS = {
    sb: 'GTM-NKHKPW',
    br: 'GTM-W2BBFX5',
    uk: 'GTM-53D9MV9',
    cs: 'GTM-NSJFF7Q9',
};
